// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".address-format-from .center-label {\n  margin-left: 5px;\n  margin-right: 5px;\n  width: 110px;\n}\n", ""]);
// Exports
module.exports = exports;
